import { Button, Checkbox, Form, Input, Radio, Space, Switch, Row, Col, message } from './../../ui/ot'
// import OverviewCalendar from '../../../../../components/schedule_timeline/OverviewCalendar'
import OverviewCalendar from '../../schedule_timeline/OverviewCalendar'
import dayjs from 'dayjs'
import { useSettingAutoReplyType } from '../controller/SettingAutoReplyTypeController'
import { useSettingAutoReply } from '../controller/SettingAutoReplyController'
import { useClass } from '../controller/ClassController'
import { useEffect, useState } from 'react'
dayjs.locale('zh-tw')
const AuroReplySettingForm = () => {
    const [form] = Form.useForm()
    const [count, setCount] = useState(1)

    const getEnableName = (field, count) => {

        let formValue = form.getFieldValue(['setting_autoreply_setting_autoreply_data', field, 'enable'])
        if (formValue === 0) {
            return "在響應時間外"
        }
        else {
            return "在響應時間內"
        }
    }
    const getTime = (count) => {
        let class_id = form.getFieldValue("class_id")
        let classData = classOption.find(ele => ele?.class_id === class_id)
        let startTime = classData?.class_working_start_time
        let endTime = classData?.class_working_end_time
        let time = Array(7).fill(0).map((_, index) => ({
            "id": index,
            "start": dayjs().day(index).format('YYYY-MM-DD') + ` ${startTime}:00.000`,
            "end": dayjs().day(index).format('YYYY-MM-DD') + ` ${endTime}:00.000`,
            "color": "#228B22",
        }))
        return time
    }
    const onFinish = ({
        axiosMode, status
    }) => {
        if (axiosMode === "patch") {
            if (status === "success") {
                message.success("儲存成功")
            }
            else {
                message.error("儲存失敗")
            }
            getSettingAutoReplyOption()
        }
    }
    const onFormFinish = (values) => {
        let data = [
            {
                "setting_autoreply_id": values?.setting_autoreply_id,
                "holiday": values?.holiday ? 1 : 0,
                "setting_autoreply_class_data": [{
                    class_id: values?.class_id,
                    setting_autoreply_class_id: values?.setting_autoreply_class_id,

                }],
                "setting_autoreply_setting_autoreply_type_data": values?.setting_autoreply_setting_autoreply_type_data ?? [],
            }
        ]
        patchSettingAutoReplyData(data)
    }
    const {
        settingAutoReplyTypeOption,
        getSettingAutoReplyTypeOption
    } = useSettingAutoReplyType({
        onBefore: () => { },
        onFinish: () => { }
    })
    const {
        settingAutoReplyOption,
        getSettingAutoReplyOption,
        patchSettingAutoReplyData
    } = useSettingAutoReply({
        onBefore: () => { },
        onFinish: onFinish
    })
    const {
        classOption,
        getClassOption
    } = useClass({
        onBefore: () => { },
        onFinish: () => { }
    })
    useEffect(() => {
        getSettingAutoReplyTypeOption()
        getSettingAutoReplyOption()
        getClassOption()
    }, [])

    useEffect(() => {
        let data = settingAutoReplyOption.find(ele => true)
        let setting_autoreply_class_data = data?.setting_autoreply_class_data || []
        let setting_autoreply_class_data_first = setting_autoreply_class_data?.find(ele => true)
        let class_id = setting_autoreply_class_data_first?.class_id
        let setting_autoreply_class_id = setting_autoreply_class_data_first?.setting_autoreply_class_id
        form.setFieldsValue(
            {
                ...data,
                class_id,
                setting_autoreply_class_id,
                holiday: data?.holiday === 1 ? true : false
            }
        )
        setCount(pre => pre + 1)
    }, [settingAutoReplyOption])


    return (<Row gutter={[24, 24]}>
        <Col span={24}>
            <Row justify={"end"}>
                <Col>
                    <Button

                        onClick={() => { form.submit() }}
                        type='primary'>儲存</Button>
                </Col>
            </Row>
        </Col>
        <Col span={24}>
            <Form
                form={form}
                labelCol={{
                    span: 8
                }}
                wrapperCol={{
                    span: 16
                }}
                onValuesChange={() => {
                    setCount(pre => pre + 1)
                }}
                onFinish={(values) => {
                    onFormFinish(values)
                }}
            >

                <Form.Item
                    hidden={true}
                    label='setting_autoreply_id'
                    name="setting_autoreply_id"
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label='響應時間'
                // name="activation"
                >
                    <Switch checked={true} />
                </Form.Item>
                <Form.Item
                    label='應對方式'
                >
                    <Form.List
                        name={'setting_autoreply_setting_autoreply_type_data'}
                        initialValue={[]}
                    >
                        {(fields) => (<>
                            <Space direction={'vertical'}>
                                {fields.map((field) => (<>
                                    <Form.Item
                                        hidden={true}
                                        name={[field.name, 'enable']}
                                    >
                                        <Input />
                                    </Form.Item>
                                    <Form.Item
                                        hidden={true}
                                        name={[field.name, 'setting_autoreply_setting_autoreply_type_among']}
                                    >
                                        <Input />
                                    </Form.Item>
                                    <Form.Item
                                        hidden={true}
                                        name={[field.name, 'setting_autoreply_setting_autoreply_type_id']}
                                    >
                                        <Input />
                                    </Form.Item>
                                    <Form.Item
                                        layout={"vertical"}
                                        label={getEnableName(field.name, count)}
                                        shouldUpdate
                                        name={[field.name, 'setting_autoreply_type_id']}
                                    >
                                        <Radio.Group>
                                            <Space
                                                direction={'vertical'}
                                            >
                                                {
                                                    settingAutoReplyTypeOption.map((value) => {
                                                        return (
                                                            <Radio value={value?.setting_autoreply_type_id}>{value?.setting_autoreply_type_name}</Radio>
                                                        )
                                                    })
                                                }
                                            </Space>
                                        </Radio.Group>
                                    </Form.Item>
                                </>))}
                            </Space>
                        </>)}
                    </Form.List>
                </Form.Item>
                <Form.Item
                    valuePropName="checked"
                    label='國定假日'
                    name="holiday"
                >
                    <Checkbox  >設置國定假日的響應時間</Checkbox>
                </Form.Item>
                <Form.Item
                    hidden={true}
                    label='setting_autoreply_class_id'
                    name={"setting_autoreply_class_id"}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label='響應時段'
                    name={"class_id"}
                >
                    <Radio.Group>
                        {
                            classOption.map((value) => {
                                return <Radio value={value?.class_id}>{value?.class_name}({value?.class_working_start_time}-{value?.class_working_end_time})</Radio>
                            })
                        }
                    </Radio.Group>
                </Form.Item>
                <OverviewCalendar
                    props_items={getTime(count)}
                    onEventsChange={(data) => { console.log(JSON.parse(JSON.stringify(data))) }}
                    can_edit={false}
                    can_create_event={false}
                    simple_week_timeline={true}
                />
            </Form>
        </Col>

    </Row>)
}
export default AuroReplySettingForm
